import { createFileRoute } from '@tanstack/react-router'
import NewRatePage from '@/features/rates/components/rate-page'

export const Route = createFileRoute(
  '/_authenticated/dashboard/rates/new',
)({
  component: NewRatePage,
})
